<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <div class="operate">
      <div class="search">
        <date-picker
          v-model="search.pay_at_S"
          :position="'right'"
          placeholder="發放日期開始"
        ></date-picker>

        <date-picker
          v-model="search.pay_at_E"
          :position="'right'"
          placeholder="發放日期結束"
        ></date-picker>
      </div>
    </div>

    <convert-excel
      class="btn btn-success"
      :data="excel_json.data"
      :fields="excel_json.fields"
      :table="excel_json.table"
      :worksheet="excel_json.worksheet"
      :name="excel_json.name"
      :type="excel_json.type"
      :before-generate="() => exportExcel('audit_checklist')"
    >
      匯出身故名單律師審核清單
    </convert-excel>

    <convert-excel
      class="btn btn-primary"
      :data="excel_json.data"
      :fields="excel_json.fields"
      :table="excel_json.table"
      :worksheet="excel_json.worksheet"
      :name="excel_json.name"
      :type="excel_json.type"
      :before-generate="() => exportExcel('claim_list')"
    >
      匯出理賠名單
    </convert-excel>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import contractApi from "@/models/API/contractApi";
import datePicker from '@/components/common/DatePicker';
import ConvertExcel from "@/components/common/ConvertExcel";
import { countNoNum, convertDateFormat, convertRocDate, getTodayDate } from "@/models/HELPERS/common.js";

export default {
  name: 'exportReport',
  components: {
    BreadCrumb,
    datePicker,
    ConvertExcel
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '理賠', url: '', isActive: true },
          { name: '匯出理賠', url: '', isActive: false }
        ]
      },
      search: {
        pay_at_S: '',
        pay_at_E: ''
      },
      data: {
        page: {},
      },
      excel_json: {
        fields: {},
        data: [],
        table: '',
        worksheet: 'My Worksheet',
        name: '身故名單律師審核清單.xls',
        type: 'table'
      }
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.contractApi.page);
    },
    // 匯出Excel
    exportExcel(type) {
      if (!this.search.pay_at_S || !this.search.pay_at_E) {
        const result = { message: '請選擇日期!!', title: '匯出理賠' };
        this.contractApi.toast(() => {}, result, false);

        resolve(false);
      }

      return new Promise((resolve, reject) => {
        this.excel_json.fields = {};
        this.excel_json.data = [];

        const params = {
          ...this.search,
          'pay_status': 1,
          'sortBy': 'member_ID_number',
          'sort': 'asc',
          'PageSize': 99999,
          'PageIndex': 1,
        };
        this.contractApi.getMember(async(response) => {
          const res = response.data;
          const data = res.data.map((item, index) => {
            return {
              ...item,
              'no': countNoNum(this.data.page, index),
              'join_date': item.join_date ? convertDateFormat(item.join_date, false) : '',
              'deaad_t': item.deaad_t ? convertDateFormat(item.deaad_t, false) : '',
              'accept_at': item.accept_at ? convertDateFormat(item.accept_at, false) : '',
            }
          })

          if (type === 'audit_checklist') await this.auditChecklistTableFormatHandler(data);
          else if (type === 'claim_list') await this.claimListTableFormatHandler(data);

          resolve(true);
        }, params)
      })
    },
    // 審核清單表格格式處理
    auditChecklistTableFormatHandler(data) {
      return new Promise((resolve, reject) => {
        const pay_at_S = convertRocDate(this.search.pay_at_S, false, true);
        const pay_at_E = convertRocDate(this.search.pay_at_E, false, true);

        let thead = `<thead>
                      <tr>
                        <th colspan="9">永豐網路平台身故名單律師審核清單</th>
                      </tr>
                      <tr>
                        <th colspan="8">結案日期：${pay_at_S.year}年${pay_at_S.month}月${pay_at_S.day}日 ~ ${pay_at_E.year}年${pay_at_E.month}月${pay_at_E.day}日</th>
                        <th>製表日：${getTodayDate(true)}</th>
                      </tr>
                      <tr>
                    `,
        tbody = '<tbody>',
        tfoot = `<tfoot>
                  <tr></tr>
                  <tr></tr>
                  <tr></tr>
                  <tr></tr>
                  <tr></tr>
                  <tr></tr>
                  <tr>
                    <td colspan="2" style="vertical-align: middle; text-align: center;">永豐網路平台<br style="mso-data-placement: same-cell;">股份有限公司</td>
                    <td colspan="2" style="border-bottom: 1px solid #000;"></td>
                    <td colspan="2" align="center">永豐公司法律顧問</td>
                    <td colspan="2" style="border-bottom: 1px solid #000;"></td>
                    <td>　　年　　月　　日</td>
                  </tr>
                </tfoot>`;
        const fields = {
          '序': 'no',
          '人次': 'claim_headcount',
          '契約編號': 'number',
          '身故會員姓名': 'member_name',
          '身分證': 'member_ID_number',
          '入會日期': 'join_date',
          '身故日期': 'dead_at',
          '受理日期': 'accept_at',
          '備註': 'remark'
        };

        Object.entries(fields).forEach(([key, value]) => {
          thead += `<th>${key}</th>`;
        });

        thead += '</tr></thead>';

        data.forEach((item, index) => {
          tbody += '<tr>';

          Object.entries(fields).forEach(([key, value]) => {
            if (value === 'claim_headcount' && item.claim_headnum !== 0) {
              tbody += `<td rowspan="${item.claim_headnum}">${item[value]}</td>`;
            } else if (value === 'join_date' || value === 'dead_at' || value === 'accept_at') {
              tbody += `<td style="mso-number-format:\'yyy-mm-dd\'">${convertRocDate(item[value])}</td>`;
            } else if (value !== 'claim_headcount') {
              tbody += `<td>${item[value] !== null && item[value] !== undefined ? item[value] : ''}</td>`;
            }

          })

          tbody += '</tr>';
        })

        tbody += '</tbody>';

        this.excel_json.table = thead + tbody + tfoot;
        this.excel_json.name = '身故名單律師審核清單.xls'

        resolve(true);
      })
    },
    // 理賠名單表格格式處理
    claimListTableFormatHandler(data) {
      return new Promise((resolve, reject) => {
        let thead = `<thead>
                      <tr>
                        <th colspan="14">永豐網路平台股份有限公司理賠名單</th>
                        <th>製表日：${getTodayDate(true)}</th>
                      </tr>
                      <tr>
                    `,
        tbody = '<tbody>';
        const fields = {
          '序': 'no',
          '人次': 'claim_headcount',
          '契約編號': 'number',
          '互助人': 'member_name',
          '要助人': 'pay_name',
          '受款人行動電話': 'beneficiary_cellphone',
          '申請書': '',
          '切結書': '',
          '死亡證明書': '',
          '除戶證明': '',
          '戶籍謄本': '',
          '要助書': '',
          '要助人、受款人變更申請書': '',
          '身分證影本': '',
          '備註': 'remark'
        };

        Object.entries(fields).forEach(([key, value]) => {
          thead += `<th>${key}</th>`;
        });

        thead += '</tr></thead>';

        data.forEach((item, index) => {
          tbody += '<tr>';

          Object.entries(fields).forEach(([key, value]) => {
            if (value === 'claim_headcount' && item.claim_headnum !== 0) {
              tbody += `<td rowspan="${item.claim_headnum}">${item[value]}</td>`;
            } else if (value === 'beneficiary_cellphone') {
              tbody += `<td style="mso-number-format:'\\@'">${item[value] !== null && item[value] !== undefined ? item[value] : ''}</td>`;
            } else if (value !== 'claim_headcount') {
              tbody += `<td>${item[value] !== null && item[value] !== undefined ? item[value] : ''}</td>`;
            }

          })

          tbody += '</tr>';
        })

        tbody += '</tbody>';

        this.excel_json.table = thead + tbody;
        this.excel_json.name = '理賠名單.xls'

        resolve(true);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/exportClaim.vue